<div class="ebu-wrapper">
    <div class="ebu-title-card m-container">
        <div>
            <div class="ebu-title">
                {{data?.title}}
            </div>
            <div class="ebu-subtitle">
                {{data?.subtitle}}
            </div>
        </div>
        <div class="cursor">
            <img src="../../../../assets/images/x-close.svg" alt="Close" (click)="closeDialog()" />
        </div>
    </div>
    <div class="ebu-message-container m-container">
        <div>
            <img src="../../../../assets/images/error.svg" alt="Warning"/>
        </div>
        <div class="ebu-message">
            The complete inventory needs to be downloaded and then modifications/additions/removals to be performed by the user. The uploaded inventory will be updated completely. Please ensure correctness of data prior to upload.
        </div> 
    </div>
    <div class="ebu-inv-download m-container">
        <div>Inventory</div> <div class="cursor"><img src="../../../../assets/images/download-inventory.svg" alt="download-inventory" (click)="downloadInventory()" /></div>
    </div>
    <div class="m-container"> 
        <app-file [formControl]="file"  [folder]="'documents'"
            [image]="'kb_defaultfile.svg'" [isFileTypeImage]="true" (uploadResponse)="uploadResponse($event, 'file')"
            [requiredFileType]="fileMimeTypes" [pageType]="'downloadInventory'">
        </app-file>
        <div *ngIf="fileError" class="d-flex justify-content-center red">Please upload file of type xls or xlsx!</div>
    </div>
    <div class="ebu-button-basket m-container">
        <button class="primary w-50 ebu-button-cancel" (click)="closeDialog()">
            Cancel
        </button>
        <button class="primary w-50 ebu-button-submit" [disabled]="!file?.value" [ngClass]="{'disabled': !file?.value || fileError}" (click)="bulkUpload()">
            Sync from File
        </button>
    </div>
</div>